module.exports = __webpack_public_path__ + "static/media/EditPencil.01f01dbc.svg";